import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import NGphoto from '../../assets/images/NG_all.png'
import NGphoto2 from '../../assets/images/NG_all_2.png'

function mapStateToProps(state: any) {
  return {}
}

const ExamplePhotoNG = (props: any) => {
  const {
    tabName,
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()

  return (
    <div className="col-1 border-s border-gray-300" style={tabName === "itemRemoval" ? {height: '528px', display: 'flex', flexDirection: 'column', padding: '12px', overflow: 'hidden'} : {}}>
      <div className="overflow-hidden bg-white rounded" style={tabName === "itemRemoval" ? {flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'} : {}}>
        {tabName != "itemRemoval"
          ? <img src={NGphoto} alt="写真の撮り方" className="w-full mx-auto"/>
          : <img src={NGphoto2} alt="写真の撮り方" style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', display: 'block'}}/>
        }
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ExamplePhotoNG)